import type { PlatformMessageAttachment } from '@liks/backend-svc-api/esm/models/index';

const IMAGE_EXTENSIONS = /\.(png|jpe?g|gif|webp|svg|bmp|ico|avif)$/i;

export type ChatMessageAttachment = PlatformMessageAttachment & { id: string };

export function getAttachmentDisplayName(
  attachment: Pick<ChatMessageAttachment, 'fileName' | 'documentName'>,
): string {
  const fileName = attachment.fileName?.trim();
  if (fileName) {
    return fileName;
  }
  const documentName = attachment.documentName?.trim();
  if (documentName) {
    return documentName;
  }
  return 'attachment';
}

export function isImageAttachment(
  attachment: Pick<
    ChatMessageAttachment,
    'attachmentType' | 'mimeType' | 'fileName' | 'documentName'
  >,
): boolean {
  if (attachment.attachmentType === 'GENERATED_IMAGE') {
    return true;
  }
  if (
    typeof attachment.mimeType === 'string' &&
    attachment.mimeType.startsWith('image/')
  ) {
    return true;
  }
  const name = attachment.fileName ?? attachment.documentName;
  return typeof name === 'string' && IMAGE_EXTENSIONS.test(name);
}

export function isAudioAttachment(
  attachment: Pick<ChatMessageAttachment, 'attachmentType' | 'mimeType'>,
): boolean {
  return (
    attachment.attachmentType === 'AUDIO' ||
    (typeof attachment.mimeType === 'string' &&
      attachment.mimeType.startsWith('audio/'))
  );
}

export function isAssistantImageAttachment(
  attachment: Pick<
    ChatMessageAttachment,
    'attachmentType' | 'mimeType' | 'fileName' | 'documentName'
  >,
): boolean {
  if (attachment.attachmentType === 'GENERATED_IMAGE') {
    return true;
  }
  return isImageAttachment(attachment);
}

export function hasAttachmentId(
  attachment: PlatformMessageAttachment,
): attachment is ChatMessageAttachment {
  return typeof attachment.id === 'string' && attachment.id.length > 0;
}
